export default "__VITE_ASSET__7f9a5199__"